<template>
    <div>
        <ul class="editpromenu">
            <li v-if="checkRoleMenu('dashboard')" :class="{'wdropdown' : true, 'cur': isActiveDashBoard }"
                @mouseover="openDashboard = true"
                @mouseleave="openDashboard = false">
                <div class="dropdown">
                    <span class="dropbtn"><router-link :to="{ name: 'home'}">Dashboard</router-link></span>
                    <div class="dropdown-content" v-bind:style='{"display" : (openDashboard ? "block" : "none" )}'>
                        <router-link :to="{ name: 'home'}">Message</router-link>
                        <router-link :to="{ name: 'home'}" v-if="checkPermissionClinic()">Food</router-link>
                        <router-link :to="{ name: 'home'}" v-if="checkPermissionClinic()">Infusion</router-link>
                        <router-link :to="{ name: 'log-epcs'}">EPCS Log</router-link>
                    </div>
                </div>
            </li>

            <li  :class="{'wdropdown' : true, 'cur': isActiveUser }"
                @mouseover="openUser = true"
                @mouseleave="openUser = false">
                <div class="dropdown">
                    <span class="dropbtn">Users</span>
                    <div class="dropdown-content" v-bind:style='{"display" : (openUser ? "block" : "none" )}'>
                        <router-link :to="{name: 'list-doctor'}">Doctor</router-link>
                        <router-link :to="{name: 'list-clinic'}">Clinic</router-link>
                        <router-link :to="{name: 'list-group'}">Group</router-link>
                        <router-link :to="{name: 'list-regular-user'}">Regular User</router-link>
                    </div>
                </div>
            </li>

            <!--<li :class="{'wdropdown' : true, 'cur': isActiveClinic }"-->
                <!--@mouseover="openClinic = true"-->
                <!--@mouseleave="openClinic = false">-->
                <!--<div class="dropdown">-->
                    <!--<span class="dropbtn"><router-link to="/clinics">Clinic</router-link></span>-->
                    <!--<div class="dropdown-content" v-bind:style='{"display" : (openClinic ? "block" : "none" )}'>-->
                        <!--<router-link to="/clinics">Clinics</router-link>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</li>-->
            <li v-if="checkRoleMenu('flow-chart')" :class="{'wdropdown' : true, 'cur': isActiveFlowChart }"
                @mouseover="openFlowChart = true"
                @mouseleave="openFlowChart = false">
                <div class="dropdown">
                      <span class="dropbtn">
                        <router-link to="/events-list">Flow Chart</router-link>
                      </span>
                    <div class="dropdown-content" v-bind:style='{"display" : (openFlowChart ? "block" : "none" )}'>
                        <router-link to="/events-list">Event</router-link>
                        <router-link to="#">Membership</router-link>
                        <router-link to="#">Patient Payment</router-link>
                        <router-link to="#">EMR</router-link>
                        <router-link key="groupUserCode" :to="{name: 'invitationCode', query: {'type': 2}}">Editor/Clinic</router-link>
                        <router-link key="doctorClinicCode" :to="{name: 'invitationEditorCode', query: {'type': 1}}"> Invitation editor code</router-link>
                    </div>
                </div>
            </li>

            <li  :class="{'wdropdown' : true, 'cur': isActiveSeo }"
                 @mouseover="openSeo = true"
                 @mouseleave="openSeo = false"
            >
              <div class="dropdown">
                <span class="dropbtn">Seo</span>
                <div class="dropdown-content" v-bind:style='{"display" : (openSeo ? "block" : "none" )}'>
                  <router-link :to="{name: 'seo-newsfeed'}">Newsfeed</router-link>
                  <router-link :to="{name: 'seo-question'}">Question</router-link>
                </div>
              </div>
            </li>

            <li v-if="checkRoleMenu('appointment')" :class="{'wdropdown' : true, 'cur': isActiveAppointment }"
                @mouseover="openAppointment = true"
                @mouseleave="openAppointment = false">
                <div class="dropdown">
                    <span class="dropbtn"><router-link to="/appointment-daily">Calendar</router-link></span>
                    <div class="dropdown-content" v-bind:style='{"display" : (openAppointment ? "block" : "none" )}'>
                        <router-link to="/appointment-daily">Daily Calendar</router-link>
                        <!--<router-link to="/appointment-online-booking">Daily Check-in List</router-link>-->
                        <!--<router-link to="/appointment-online-booking">Online Booking List</router-link>-->
                        <router-link to="/calendar-daily">Daily Sales</router-link>
                        <!--<router-link to="/appointment-daily-patient">Daily Patient List</router-link>-->
                        <router-link to="/daily-sale-report">Daily Sales Report</router-link>
                        <!--<router-link v-if="checkRoleMenu('appointmentDailyAgMixingList')"-->
                                     <!--to="/appointment-daily-antigen-mixing">Daily AG Mixing List-->
                        <!--</router-link>-->
                        <!--<router-link v-if="checkRoleMenu('appointmentDailyAgMixingReport')" to="/daily-mixing-report">-->
                            <!--Daily AG Mixing Report-->
                        <!--</router-link>-->
                    </div>
                </div>
            </li>
            <li :class="{'wdropdown' : true, 'cur': isActiveBill }"
                @mouseover="openBill = true"
                @mouseleave="openBill = false">
                <div class="dropdown">
                    <span class="dropbtn">
                        <router-link to="/event-billing" >Transaction</router-link>
                    </span>
                    <div class="dropdown-content" v-bind:style='{"display" : (openBill ? "block" : "none" )}'>
                        <router-link to="/event-billing">Processing</router-link>
                        <router-link to="/event-billing-settled">Settled</router-link>
                        <router-link to="/event-billing-settled"  >Vendor payments</router-link>
                        <router-link to="/sms-stats">SMS Statistics</router-link>
                    </div>
                </div>
            </li>
            <li :class="{'wdropdown' : true, 'cur': isActive }" @mouseover="open = true" @mouseleave="open = false">
                <div class="dropdown">
                    <span class="dropbtn">
                       <router-link v-if="user.role !== 'AllergyClinic'" to="/setting">Setting</router-link>
                       <router-link to="/clinic-settings" v-if="user.role === 'AllergyClinic'">Setting</router-link>
                    </span>
                    <div v-if="isShowMenu" class="dropdown-content"
                         v-bind:style='{"display" : (open ? "block" : "none" )}'>
                        <router-link :to="{name: 'service-setup'}">Service setup
                        </router-link>
                        <router-link to="/setup-package">Setup package</router-link>
                        <router-link to="/setup-package-wiki">Setup Package Wiki</router-link>
                        <router-link to="/procedure-and-sop">Procedure and SOP</router-link>
                        <router-link to="/store-file">Store File</router-link>
                    </div>
                    <!--menu cho regular user-->
                </div>
            </li>
            <router-link v-if="user.role === 'Admin'" tag="li" :to="{ name: 'admin'}">Admin</router-link>
            <li :class="{'wdropdown' : true, 'cur': isActiveEmrDataSetup }"
                @mouseover="openEmrDataSetup = true"
                @mouseleave="openEmrDataSetup = false">
                <div class="dropdown">
                    <span class="dropbtn">EMR Data Setup</span>
                    <div class="dropdown-content" v-bind:style='{"display" : (openEmrDataSetup ? "block" : "none" )}'>
                        <router-link :to="{name: 'emr-data-noc'}">NOC</router-link>
                    </div>
                </div>
            </li>

            <li v-if="$store.state.authenticated" class="date-now"
                title="This clock is live and is synchronized with your local PC. Please make sure your local PC clock is correct.">
                <span :inner-html.prop="dateNow.format(`[<span style='font-size:30px'>]hh:mm A[</span>] dddd, MMMM DD, YYYY`)"></span>
            </li>
        </ul>
    </div>
</template>

<script>
import Common from '../components/mixins/Common.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'Navigator',
  props: {},
  mixins: [Common],
  data () {
    return {
      user: this.$store.state.user,
      open: false,
      openDashboard: false,
      openFlowChart: false,
      openEmr: false,
      openBill: false,
      openPatient: false,
      openAppointment: false,
      openEmrDataSetup: false,

      openClinic: false,
      dateNow: moment(),
      openUser: false,
      openSeo: false
    }
  },
  mounted () {
    this.internalTime = setInterval(this.time, 1000)
  },
  methods: {
    time () {
      this.dateNow = moment()
    },
    checkRoleMenu (...permissions) {
      return true
    }
  },
  beforeDestroy () {
    if (this.internalTime) {
      clearInterval(this.internalTime)
    }
  },
  computed: {
    ...mapGetters({
      storeUser: 'user'

    }),
    isActiveBill () {
      return ['eventBilling', 'sms-stats'].indexOf(this.$route.name) > -1
    },
    isActiveAppointment () {
      return this.$route.name === 'appointmentDailyReport' ||
        this.$route.name === 'dailyMixingReport' ||
        this.$route.name === 'dailyMixingReport' ||
        this.$route.name === 'calendarDaily'
    },

    isShowMenu () {
      return true
    },

    isActiveFlowChart () {
      return [
       'doctorClinicCode', 'groupUserCode', 'eventGroup', 'invitationCode', 'invitationEditorCode'].indexOf(this.$route.name) > -1
    },
    isActive () {
      return ['setup-package', 'setup-package-wiki', 'service-setup', 'procedureandsop', 'store-file'].includes(this.$route.name)
    },
    isActiveDashBoard () {
      return this.$route.name === 'home' || this.$route.name === 'log-epcs'
    },
    isActiveUser () {
      return ['list-regular-user', 'list-doctor', 'list-clinic', 'list-group'].indexOf(this.$route.name) > -1
    },
    isActiveSeo () {
      return ['seo-newsfeed', 'seo-question'].indexOf(this.$route.name) > -1
    },
    isActiveEmrDataSetup () {
      return ['emr-data-noc'].indexOf(this.$route.name) > -1
    }
  }
}
</script>
<style scoped>
    .date-now {
        margin-left: 10px;
        float: right;
        position: absolute;
        right: 0px;
        top: -10px;
        padding-right: 0;
        background: none !important;
        border: none !important;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }

    .date-now:hover {
        color: inherit !important;
        background: none !important;
    }

    .editpromenu .cur {
        /*background: #fff;*/
        position: relative;
        bottom: -1px;
        color: #bec500;
    }
</style>
